import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { initializeApplicationVersionObserver } from './api/client';
import router from './router';
import { useApplicationUpdateStore } from './stores/applicationUpdate';
import { initializeThemeMode } from './theme';

initializeThemeMode();
const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
const applicationUpdate = useApplicationUpdateStore(pinia);
initializeApplicationVersionObserver(version => applicationUpdate.observeServerVersion(version));
app.use(router);
await router.isReady();
app.mount('#app');
